/* Home page behaviour: the hero slideshow, email signups, the "pick the look"
   vote with its Pinterest-style boards, and scroll reveals. No framework.
   Every form posts to the same /api/subscribe endpoint the site has always
   used; `source` says which form it came from, so the admin dashboard's
   "signup source" chart doubles as the vote tally ("vote: Cream", ...).
   Board images are listed in board-data.js (window.BOARD). */

(function () {
  "use strict";
  document.documentElement.classList.add("js");

  var EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  var REDUCED = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;

  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    for (var k in attrs || {}) n.setAttribute(k, attrs[k]);
    (kids || []).forEach(function (c) { n.append(c); });
    return n;
  }

  // Shuffle so whichever design comes first doesn't quietly win the vote.
  function shuffled(list) {
    var a = list.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  // ------------------------------------------------------------------ hero
  var slides = shuffled(Array.prototype.slice.call(document.querySelectorAll(".hero-slide")));
  var heroName = document.querySelector(".hero-name");
  if (slides.length) {
    var at = 0;
    var showSlide = function (i) {
      slides.forEach(function (s, k) { s.classList.toggle("is-on", k === i); });
      if (heroName) heroName.textContent = slides[i].dataset.name;
    };
    showSlide(0);
    if (!REDUCED) setInterval(function () { at = (at + 1) % slides.length; showSlide(at); }, 3800);
  }

  // --------------------------------------------------------------- designs
  var IMG = window.BAS_NANAS_ASSETS + "brand-";
  var BOARD_IMG = window.BAS_NANAS_ASSETS + "board-";
  var BOARD = window.BOARD || {};
  var FLAVORS = ["Original", "Strawberry", "Blueberry", "Matcha"];
  var CATS = [["all", "All"], ["lifestyle", "Lifestyle"], ["retail", "Retail"], ["packaging", "Packaging"], ["merch", "Merch"]];
  var DESIGNS = [
    { id: "yellow", name: "Design 1",
      desc: "Loud, spotty and a little retro, with a thumbs-up banana mascot front and center." },
    { id: "cream", name: "Design 2",
      desc: "Clean and calm. A big friendly wordmark and one ripe banana, with a color band for each flavor." },
    { id: "vertical", name: "Design 3",
      desc: "The wordmark wraps around one tall spotted banana, with the ingredients printed right on the front." },
    { id: "d4", name: "Design 4", flavors: ["Original"],
      desc: "A runner carrying bananas on a shoulder pole in front of a red sun, on bright yellow." },
    { id: "d5", name: "Design 5", flavors: ["Strawberry"],
      desc: "One big smiling banana on hot pink." },
    { id: "d6", name: "Design 6", flavors: ["Original"],
      desc: "A green banana bunch and leaf, with a tall red wordmark on cream." },
    { id: "d7", name: "Design 7", flavors: ["Strawberry"],
      desc: "A diagonal wordmark splits cream from the flavor color." },
    { id: "d8", name: "Design 8", flavors: ["Strawberry"],
      desc: "A hand holding bananas, with portraits of ba and ma, in bold red, blue and yellow." },
    { id: "d9", name: "Design 9", flavors: ["Original"],
      desc: "A retro script wordmark on cream with polka dots and a red flavor band." },
    { id: "d10", name: "Design 10", flavors: ["Original", "Strawberry", "Matcha"],
      desc: "Freckles and a chunky wordmark on soft pink." },
    { id: "d11", name: "Design 11", flavors: ["Original"],
      desc: "A bubbly wordmark and a banana sticker on sunny yellow freckles." },
    { id: "d12", name: "Design 12", flavors: ["Original"],
      desc: "The same bubbly look in a softer, paler yellow." },
    { id: "d13", name: "Design 13", flavors: ["Original", "Strawberry", "Blueberry", "Matcha"],
      desc: "Banana bunches and big leaves on deep green." },
    { id: "d14", name: "Design 14", flavors: ["Original", "Strawberry", "Blueberry", "Matcha"],
      desc: "A script wordmark on cream, with a flavor-colored banana and band." }
  ];

  var tabs = document.querySelector(".vote-tabs");
  var panel = document.querySelector(".vote-panel");
  var board = document.querySelector(".board");
  var filters = document.querySelector(".board-filters");
  var countEl = document.querySelector(".board-count");
  var current = null;
  var filter = "all";
  var visible = [];

  function restart(node, cls) {
    if (REDUCED) return;
    node.classList.remove(cls);
    void node.offsetWidth;
    node.classList.add(cls);
  }

  function renderBoard(animate) {
    var items = BOARD[current.id] || [];
    if (filter === "all") {
      // Deal the categories out like cards so retail, packaging and merch are
      // spread across the board instead of bunching up in one column.
      var piles = {};
      items.forEach(function (it) { (piles[it.cat] = piles[it.cat] || []).push(it); });
      var order = ["lifestyle", "retail", "lifestyle", "packaging", "lifestyle", "merch"];
      visible = [];
      while (visible.length < items.length) {
        order.forEach(function (c) { if (piles[c] && piles[c].length) visible.push(piles[c].shift()); });
      }
    } else {
      visible = items.filter(function (it) { return it.cat === filter; });
    }
    board.replaceChildren.apply(board, visible.map(function (it, i) {
      var b = el("button", { type: "button", class: "pin", "data-i": i, "aria-label": "Open " + it.label });
      var img = el("img", { src: BOARD_IMG + it.src, alt: current.name + " can: " + it.label,
                            width: it.w, height: it.h, loading: "lazy", decoding: "async" });
      var done = function () { img.classList.add("loaded"); };
      if (img.complete && img.naturalWidth) done(); else { img.addEventListener("load", done); img.addEventListener("error", done); }
      b.append(img, el("figcaption", {}, [it.label]));
      return b;
    }));
    if (animate) restart(board, "swap");
    collapse(true);
  }

  // Boards open at about two rows; "Show all" expands the rest so the page
  // isn't a long scroll before the story and the signup.
  var moreBtn = document.querySelector(".board-more button");
  var wrap = document.querySelector(".board-wrap");
  var expanded = false;
  function columnCount() {
    var pin = board.querySelector(".pin");
    if (!pin) return 1;
    var gap = parseFloat(getComputedStyle(board).columnGap) || 0;
    return Math.max(1, Math.round((board.clientWidth + gap) / (pin.offsetWidth + gap)));
  }
  function collapse(reset) {
    if (!moreBtn) return;
    if (reset) expanded = false;
    var pins = board.querySelectorAll(".pin");
    pins.forEach(function (p) { p.hidden = false; });
    var keep = columnCount() * 2;
    var fits = pins.length <= keep;
    if (!expanded && !fits) pins.forEach(function (p, i) { p.hidden = i >= keep; });
    wrap.classList.toggle("collapsed", !expanded && !fits);
    moreBtn.parentNode.hidden = fits;
    moreBtn.setAttribute("aria-expanded", String(expanded));
    moreBtn.textContent = expanded ? "Show fewer" : "Show all " + visible.length + " images";
  }
  if (moreBtn) {
    moreBtn.addEventListener("click", function () {
      expanded = !expanded;
      collapse(false);
      if (!expanded) document.querySelector(".board-head").scrollIntoView({ block: "start", behavior: REDUCED ? "auto" : "smooth" });
    });
    window.addEventListener("resize", function () { collapse(false); });
  }

  function renderFilters() {
    var items = BOARD[current.id] || [];
    var present = {};
    items.forEach(function (it) { present[it.cat] = (present[it.cat] || 0) + 1; });
    if (filter !== "all" && !present[filter]) filter = "all";
    filters.replaceChildren.apply(filters, CATS.filter(function (c) { return c[0] === "all" || present[c[0]]; })
      .map(function (c) {
        var b = el("button", { type: "button", "aria-pressed": String(c[0] === filter), "data-cat": c[0] },
                   [c[1] + (c[0] === "all" ? "" : " " + present[c[0]])]);
        b.addEventListener("click", function () {
          filter = c[0];
          Array.prototype.forEach.call(filters.children, function (x) { x.setAttribute("aria-pressed", String(x === b)); });
          renderBoard(true);
        });
        return b;
      }));
    countEl.textContent = items.length + " images";
  }

  function show(design, animate) {
    current = design;
    Array.prototype.forEach.call(tabs.children, function (t) {
      var on = t.dataset.id === design.id;
      t.setAttribute("aria-selected", on ? "true" : "false");
      t.tabIndex = on ? 0 : -1;
    });
    var lineup = panel.querySelector(".vote-lineup");
    var flavors = design.flavors || FLAVORS;
    lineup.style.setProperty("--n", flavors.length);
    lineup.replaceChildren.apply(lineup, flavors.map(function (f) {
      return el("figure", {}, [
        el("img", { src: IMG + "can-" + design.id + "-" + f.toLowerCase() + ".webp",
                    alt: design.name + " can, " + f, width: 480, height: 952 }),
        el("figcaption", {}, [f])
      ]);
    }));
    panel.querySelector(".vote-name").textContent = design.name;
    panel.querySelector(".vote-desc").textContent = design.desc;
    var voteTags = document.querySelector(".vote-form input[name=\"contact[tags]\"]");
    if (voteTags) voteTags.value = "presale, vote: " + design.name;
    document.querySelectorAll(".vote-pick").forEach(function (n) { n.textContent = design.name; });
    renderFilters();
    renderBoard(animate);
    if (animate) restart(panel, "swap");
    document.dispatchEvent(new CustomEvent("bn:design", { detail: { id: design.id, name: design.name } }));
  }

  if (tabs && panel && board) {
    // Tabs stay in 1-2-3 order; a random one opens first so no design always gets the first look.
    var first = Math.floor(Math.random() * DESIGNS.length);
    DESIGNS.forEach(function (d, i) {
      var b = el("button", { type: "button", class: "vote-tab", role: "tab", "data-id": d.id, "data-track": "vote tab " + d.name }, [
        el("img", { src: IMG + "can-" + d.id + "-" + (d.flavors || FLAVORS)[0].toLowerCase() + ".webp", alt: "", width: 40, height: 40 }),
        d.name
      ]);
      b.addEventListener("click", function () { if (current !== d) show(d, true); });
      tabs.append(b);
      if (i === first) show(d, false);
    });
    tabs.addEventListener("keydown", function (e) {
      if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
      var list = Array.prototype.slice.call(tabs.children);
      var i = list.indexOf(document.activeElement);
      if (i < 0) return;
      var next = list[(i + (e.key === "ArrowRight" ? 1 : list.length - 1)) % list.length];
      next.focus(); next.click();
    });
  }

  // -------------------------------------------------------------- lightbox
  var lb = document.querySelector(".lightbox");
  if (lb && board && lb.showModal) {
    var lbImg = lb.querySelector("img");
    var lbCap = lb.querySelector("figcaption");
    var lbAt = 0;
    var open = function (i) {
      lbAt = (i + visible.length) % visible.length;
      var it = visible[lbAt];
      lbImg.src = BOARD_IMG + it.src;
      lbImg.alt = current.name + " can: " + it.label;
      lbCap.textContent = current.name + ": " + it.label + "  (" + (lbAt + 1) + " of " + visible.length + ")";
      if (!lb.open) lb.showModal();
    };
    board.addEventListener("click", function (e) {
      var pin = e.target.closest(".pin");
      if (pin) open(+pin.dataset.i);
    });
    lb.querySelector(".lb-prev").addEventListener("click", function () { open(lbAt - 1); });
    lb.querySelector(".lb-next").addEventListener("click", function () { open(lbAt + 1); });
    lb.querySelector(".lb-close").addEventListener("click", function () { lb.close(); });
    lb.addEventListener("click", function (e) { if (e.target === lb) lb.close(); });
    lb.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") open(lbAt + 1);
      if (e.key === "ArrowLeft") open(lbAt - 1);
    });
  }

  // --------------------------------------------------------------- reveals
  var items = document.querySelectorAll(".reveal");
  if (!("IntersectionObserver" in window)) {
    items.forEach(function (n) { n.classList.add("in"); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
    });
  }, { rootMargin: "0px 0px -8% 0px", threshold: 0.12 });
  items.forEach(function (n) { io.observe(n); });
})();
